import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private renderer: Renderer2;
  private isScrollDisabled = false;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  enableScroll(): void {
    if (this.isScrollDisabled) {
      this.renderer.removeStyle(document.body, 'overflow');
      this.renderer.removeStyle(document.body, 'padding-right');
      this.isScrollDisabled = false;
    }
  }

  disableScroll(): void {
    if (!this.isScrollDisabled) {
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
      this.renderer.setStyle(document.body, 'padding-right', '17px');
      this.isScrollDisabled = true;
    }
  }

  isScrollingDisabled(): boolean {
    return this.isScrollDisabled;
  }
}